const t = {
  name: "EthernetFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9998 2H7.99977V8H5.99977V2H0.00976562V15C0.00976562 16.6523 1.35748 18 3.00977 18H5.38982L6.55411 20.3447L6.55534 20.3472C7.06324 21.363 8.09768 22.01 9.23977 22.01H14.7698C15.9119 22.01 16.9463 21.363 17.4542 20.3472L17.4554 20.3447L18.6197 18H20.9998C22.6521 18 23.9998 16.6523 23.9998 15V2H17.9998V8H15.9998V2H12.9998V8H10.9998V2ZM14.9998 16V18H8.99977V16H14.9998Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as EthernetFilled
};
